// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabViewModel from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import TicketAssignmentViewModel from "./ticket-assignment";
import TicketReferenceDocumentViewModel from "./ticket-reference-document";
import TicketEscalationViewModel from "./ticket-escalation";
import TicketEvaluationViewModel from "./ticket-evaluation";
import SearchPaging from "./../factories/search-paging";
import baoRouter from "./../services/bao-router";
import TreeNodeViewModel from "./../factories/tree-node";
import * as moment from "moment";
import TicketAuditDialog from "./../factories/ticket-audit-dialog";
import SendMailDialog from "./../factories/send-mail-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/foreach-selection";
import "./../bindings/slide-visible";
import "./../bindings/bao-tabs";
import "./../bindings/bao-tree";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import AppTabController from "../services/app-tab-controller";

function TicketTemplateDialog(value) {
    var self = this;
    self.Dialog = null;
    self.Bao = Bao;
    self.SelectedItem = ko.observable();
    self.Items = ko.observableArray();
    self.Deferred = $.Deferred();
    self.SelectItem = function (item) {
        self.Deferred.resolve(item);
        if (self.Dialog != null && self.Dialog.Close != null) {
            self.Dialog.Close();
        }
    };
    self.OpenDialog = function () {
        Bao.post("TicketTemplate/SelectTicketTemplateDialog", function (result) {
            if (result.Models != null && result.Models.length > 0) {
                self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                self.Items(result.Models);
                self.Dialog.ViewModel(self);
                self.Dialog.Buttons([{
                        Title: Bao.Session.GetMessage("msgOk"),
                        Click: function () {
                            self.Deferred.resolve(self.SelectedItem());
                            self.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }, {
                        Title: Bao.Session.GetMessage("msgCancel"),
                        Click: function () {
                            self.Deferred.resolve();
                            self.Dialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }]);
                self.Dialog.Closed = function () {
                    self.Deferred.resolve();
                };
                self.Dialog.Template(result.Message);
                self.Dialog.Open();
            }
            else {
                self.Deferred.resolve(false);
            }
        });
        return self.Deferred.promise();
    };
}
function TicketViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicket");
    var _saveMessage = Bao.Session.GetMessage("msgSaveCheck");
    var _msgYes = Bao.Session.GetMessage("msgYes");
    var _msgNo = Bao.Session.GetMessage("msgNo");
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _ticketCloseMessage = Bao.Session.GetMessage("msgTicketCloseQuestion");
    var _msgOnHoldDateFuture = Bao.Session.GetMessage("msgOnHoldWrongDate");
    var _msgMandatoryFields = Bao.Session.GetMessage("msgFillMandatorFields");
    var tabPageDescription, tabPageDiary, tabPageDocuments, tabPageAssignment, tabPageEscalation, tabPageEvaluation;
    var diaryLoaded = false;
    self.Bao = Bao;
    self.TabPage = tabPage;
    self.TabViewModel = new TabViewModel(false);
    self.TicketStatusOnHold = "ced7fac3-1660-4f71-9ec6-cabc7cc7ecc4";
    self.TicketStatusClosed = "82eb2417-2708-4de7-8117-d1a52775b128";
    self.TicketStatusWaitsForApproval = "3a9a5ead-53ad-48d7-8ed4-abfa95516018";
    self.TicketId = ko.observable().extend({
        dirty: self.TabPage.DirtyFlag
    });
    self.TicketNr = ko.observable();
    self.TicketLoaded = ko.observable(false);
    self.TicketLocked = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.ApprovalAllowed = ko.observable();
    self.OnHoldUntilVisible = ko.observable(false);
    self.IsAffectedPersonAllowed = ko.observable(false);
    self.AffectedPersonId = ko.observable();
    self.IsReportingPersonAllowed = ko.observable(false);
    self.ReportingPersonId = ko.observable();
    self.IsAffectedConfigurationItemAllowed = ko.observable(false);
    self.AffectedConfigurationItemId = ko.observable();
    self.IsCauseConfigurationItemAllowed = ko.observable(false);
    self.CauseConfigurationItemId = ko.observable();
    self.HasDocuments = ko.observable(false);
    self.nodes = ko.observableArray();
    self.IsLoading = ko.observable(false);
    self.SelectedHistoryRow = ko.observable();
    self.SelectedReferenceDocumentRow = ko.observable();
    self.IsHistory = ko.observable(false);
    self.DiaryHistory = ko.observable();
    self.HasDiary = ko.observable(false);
    self.DocumentsToDelete = ko.observableArray([]);
    self.TicketPriorityId = ko.observable();
    self.OnHoldUntilJs = ko.observable();
    self.TicketStatusId = ko.observable();
    self.ClosedByUserId = ko.observable();
    self.SaveTime = ko.observable();
    self.SelectedCategory = ko.observable();
    self.SelectedService = ko.observable();
    self.ApprovalRequired = ko.observable();
    self.TicketApproveStateId = ko.observable();
    self.TicketCategoryId = ko.observable();
    self.TicketTypeCategoryName = ko.observable("");
    self.ActionCloseDialogIsOpen = ko.observable(false);
    self.ProblemRawValue = ko.observable("");
    self.ProblemUserTaggingList = ko.observableArray([]);
    self.SolutionRawValue = ko.observable("");
    self.SolutionUserTaggingList = ko.observableArray([]);
    self.showUserTaggingControl = ko.observable(true);
    self.SetReactedButtonVisible = ko.observable(false);
    self.UpdateReactedButtonVisible = function () {
        var model = ko.map.toJS(self, true);
        return Bao.post("Ticket/IsSetReactedButtonVisible", JSON.stringify({
            ticketModel: model,
            sessionTabId: self.TabPage.SessionTabId
        }), function (result2) {
            self.SetReactedButtonVisible(result2);
        });
    };
    self.InfoId = ko.observable();
    self.InitParam = function () {
        var data = self.TabPage.UrlData();
        if (data !== null) {
            var problem = data.problemText;
            if (problem !== null && problem !== undefined) {
                self.Problem(problem);
            }
            var infoId = data.infoId;
            if (infoId !== null && infoId !== undefined) {
                self.InfoId(infoId);
            }
        }
    };
    self.SetReacted = function () {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SetReacted"), "yesno");
        questionDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                self.TabPage.IsLoading(true);
                Bao.post("Ticket/SetReactionTime", JSON.stringify({
                    ticketId: self.TicketId(),
                    sessionTabId: self.TabPage.SessionTabId
                }), function (value) {
                    if (tabPageEscalation != null) {
                        tabPageEscalation.ViewModel().PerformRefresh().then(function () {
                            self.UpdateReactedButtonVisible().then(function () {
                                self.TabPage.IsLoading(false);
                            });
                        });
                    }
                    else {
                        self.UpdateReactedButtonVisible().then(function () {
                            self.TabPage.IsLoading(false);
                        });
                    }
                });
            }
        });
    };

    /**
     * Function to toggling buttons.
     * All new buttons should be supported in this function
     * */
    self.ToggleButtons = function () {
        
        let enableBackwardButton = false;
        let enableForwardButton = false;

        if ((<any>self.TabPage).IsNew || self.CurrentTotalCount() <= 1 || self.CurrentTotalCount() == null || self.IsHistory() || (self.CurrentSearchIndex() == null)) {
            enableBackwardButton = false;
            enableForwardButton = false;
        }
        else {
            if (self.CurrentSearchIndex() == 0) {
                enableBackwardButton = false;
                enableForwardButton = true;
            }
            else if (self.CurrentSearchIndex() == (self.CurrentTotalCount() - 1)) {
                enableBackwardButton = true;
                enableForwardButton = false;
            }
            else {
                enableBackwardButton = true;
                enableForwardButton = true;
            }
        }

        // start Backward/Forward buttons
        BaoMenu.permissionEnable({
            ActionKey: TicketViewModel.prototype.PermissionBackward,
            Enabled: enableBackwardButton,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: TicketViewModel.prototype.PermissionForward,
            Enabled: enableForwardButton,
            Context: tabPage.Context()
        });
        // end Backward/Forward buttons
        // start Refresh Button
        BaoMenu.permissionEnable({
            ActionKey: TicketViewModel.prototype.PermissionRefresh,
            Enabled: !self.IsNew(),
            Context: tabPage.Context()
        });
        // end Refresh Button

    };
    self.AlertCss = ko.computed(function () {
        if (self.TicketApproveStateId() == "032ea19f-04fd-47e0-8599-e380f8cc305e") {
            return "alert-success";
        }
        else if (self.TicketApproveStateId() == "76ae59cf-5d75-40dc-9a62-ce2ef66df142") {
            return "alert-danger";
        }
        return "alert-info";
    });
    self.subscribe(self.TicketNr, function (newValue) {
        if (newValue != null && newValue > 0) {
            tabPage.ObjectId(newValue);
        }
    });
    self.subscribe(self.TicketId, function () {
        self.TabViewModel.Tabs([]);
        tabPageDescription = new TabPage();
        tabPageDescription.AutoSelect = true;
        tabPageDescription.Url("Ticket/RequestSolutionTab/" + self.TicketId());
        tabPageDescription.Title = Bao.Session.GetMessage("msgTicketTabDescription");
        tabPageDescription.IsClosable(false);
        tabPageDescription.ViewModel(self);
        tabPageDescription.TabLoaded = function () { };
        tabPageDiary = new TabPage();
        tabPageDiary.AutoSelect = false;
        tabPageDiary.Url("Ticket/DiaryTab/" + self.TicketId());
        tabPageDiary.Title = Bao.Session.GetMessage("msgTicketTabDiary");
        tabPageDiary.IsClosable(false);
        tabPageDiary.ViewModel(self);
        tabPageDiary.PreLoad(false);
        tabPageDiary.TabLoaded = function () {
            diaryLoaded = true;
            self.RefreshDiary();
        };
        tabPageDocuments = new TabPage();
        tabPageDocuments.AutoSelect = false;
        tabPageDocuments.Url("Ticket/TicketReferenceDocumentTab/" + self.TicketId());
        tabPageDocuments.Title = Bao.Session.GetMessage("msgTicketTabDocuments");
        tabPageDocuments.IsClosable(false);
        tabPageDocuments.ViewModel(new TicketReferenceDocumentViewModel(tabPageDocuments, self));
        tabPageDocuments.PreLoad(false);
        tabPageDocuments.TabLoaded = function () {
            tabPageDocuments.ViewModel().RefreshGrid();
        };
        tabPageAssignment = new TabPage();
        tabPageAssignment.AutoSelect = false;
        tabPageAssignment.Url("Ticket/TicketAssignmentTab/" + self.TicketId());
        tabPageAssignment.Title = Bao.Session.GetMessage("msgTicketTabAssignment");
        tabPageAssignment.IsClosable(false);
        tabPageAssignment.ViewModel(new TicketAssignmentViewModel(tabPageAssignment, self));
        tabPageAssignment.PreLoad(true);
        tabPageAssignment.TabLoaded = function () {
            tabPageAssignment.ViewModel().RefreshGrid();
        };
        tabPageAssignment.Visible = ko.computed(function () {
            return self.IsHistory() == false;
        });
        self.TabViewModel.AddTab(tabPageDescription);
        self.TabViewModel.AddTab(tabPageDiary);
        self.TabViewModel.AddTab(tabPageDocuments);
        self.TabViewModel.AddTab(tabPageAssignment);
        var createEscalationTab = function () {
            if (tabPageEscalation == null) {
                tabPageEscalation = new TabPage();
                tabPageEscalation.AutoSelect = false;
                tabPageEscalation.Url("Ticket/EscalationTab/" + self.TicketId());
                tabPageEscalation.Title = Bao.Session.GetMessage("msgTicketTabEscalation");
                tabPageEscalation.IsClosable(false);
                tabPageEscalation.ViewModel(new TicketEscalationViewModel(tabPageEscalation, self));
                tabPageEscalation.PreLoad(true);
                tabPageEscalation.Visible = ko.computed(function () {
                    return self.IsHistory() == false;
                });
                self.TabViewModel.AddTab(tabPageEscalation);
            }
        };
        Bao.Session.HasPermission("EscalationTabVisible", "1A38B671-948C-42EE-B80D-F6B9A12814B6").subscribe(function (hasPermission) {
            if (hasPermission) {
                createEscalationTab();
            }
        });
        if (Bao.Session.HasPermission("EscalationTabVisible", "1A38B671-948C-42EE-B80D-F6B9A12814B6")()) {
            createEscalationTab();
        }
        var createEvaluationTab = function () {
            if (tabPageEvaluation == null) {
                tabPageEvaluation = new TabPage();
                tabPageEvaluation.AutoSelect = false;
                tabPageEvaluation.Url("Ticket/EvaluationTab/" + self.TicketId());
                tabPageEvaluation.Title = Bao.Session.GetMessage("msgTicketTabEvaluation");
                tabPageEvaluation.IsClosable(false);
                tabPageEvaluation.ViewModel(new TicketEvaluationViewModel(tabPageEvaluation, self));
                tabPageEvaluation.PreLoad(true);
                tabPageEvaluation.Visible = ko.computed(function () {
                    return self.IsHistory() == false;
                });
                self.TabViewModel.AddTab(tabPageEvaluation);
            }
        };
        Bao.Session.HasPermission("EvaluationTabVisible", "1A38B671-948C-42EE-B80D-F6B9A12814B6").subscribe(function (hasPermission) {
            if (hasPermission) {
                createEvaluationTab();
            }
        });
        if (Bao.Session.HasPermission("EvaluationTabVisible", "1A38B671-948C-42EE-B80D-F6B9A12814B6")()) {
            createEvaluationTab();
        }
    });
    self.UpdateEscalation = function () {
        var model = ko.map.toJS(self, true);
        self.TabPage.IsLoading(true);
        return Bao.post("Ticket/SetTicketEscalationByTicket", JSON.stringify({
            ticketModel: model,
            sessionTabId: self.TabPage.SessionTabId
        }), function (result) {
            if (result != null && result.TicketId != null && tabPageEscalation != null) {
                tabPageEscalation.ViewModel().SetValuesByModel(result);
            }
            self.UpdateReactedButtonVisible().then(function () {
                self.TabPage.IsLoading(false);
            });
        });
    };
    self.subscribe(self.TicketPriorityId, function (ticketPriorityId) {
        if (self.TicketLoaded() == true) {
            self.UpdateEscalation();
        }
    });
    self.subscribe(self.AffectedPersonId, function (affectedPersonId) {
        if (self.TicketLoaded() == true) {
            if (affectedPersonId != null) {
                Bao.post("Ticket/IsConfigurationItemAllowed", JSON.stringify({
                    id: affectedPersonId
                }), function (value) {
                    self.IsAffectedPersonAllowed(value.returnValue);
                });
            }
            else {
                self.IsAffectedPersonAllowed(false);
            }
            self.UpdateEscalation();
        }
    });
    self.subscribe(self.ReportingPersonId, function (reportingPersonId) {
        if (self.TicketLoaded() == true) {
            if (reportingPersonId != null) {
                Bao.post("Ticket/IsConfigurationItemAllowed", JSON.stringify({
                    id: reportingPersonId
                }), function (value) {
                    self.IsReportingPersonAllowed(value.returnValue);
                });
            }
            else {
                self.IsReportingPersonAllowed(false);
            }
        }
    });
    self.subscribe(self.AffectedConfigurationItemId, function (affectedConfigurationItemId) {
        if (self.TicketLoaded() == true) {
            if (affectedConfigurationItemId != null) {
                Bao.post("Ticket/IsConfigurationItemAllowed", JSON.stringify({
                    id: affectedConfigurationItemId
                }), function (value) {
                    self.IsAffectedConfigurationItemAllowed(value.returnValue);
                });
            }
            else {
                self.IsAffectedConfigurationItemAllowed(false);
            }
        }
    });
    self.subscribe(self.CauseConfigurationItemId, function (causeConfigurationItemId) {
        if (self.TicketLoaded() == true) {
            if (causeConfigurationItemId != null) {
                Bao.post("Ticket/IsConfigurationItemAllowed", JSON.stringify({
                    id: causeConfigurationItemId
                }), function (value) {
                    self.IsCauseConfigurationItemAllowed(value.returnValue);
                });
            }
            else {
                self.IsCauseConfigurationItemAllowed(false);
            }
        }
    });
    self.subscribe(self.ApprovalRequired, function (newValue) { });
    self.subscribe(self.HasDocuments, function (newValue) {
        var icon = "";
        if (newValue) {
            icon = "fal fa-paperclip";
        }
        tabPageDocuments.Icon(icon);
    });
    self.subscribe(self.HasDiary, function (newValue) {
        var icon = "";
        if (newValue) {
            icon = "fal fa-paperclip";
        }
        tabPageDiary.Icon(icon);
    });
    self.subscribe(self.OnHoldUntilJs, function () { });
    self.subscribe(self.TicketStatusId, function (newValue) {
        if (self.ClosedDateJs != null && newValue != self.TicketStatusClosed) {
            self.ClosedDateJs("");
            self.ClosedByUserName("");
            self.ClosedByUserId(null);
        }
        if (newValue != null) {
            self.OnHoldUntilVisible(newValue.toLowerCase() == self.TicketStatusOnHold);
            if (self.OnHoldUntilVisible() == false) {
                self.OnHoldUntilJs(null);
            }
            if (newValue.toLowerCase() == self.TicketStatusClosed && self.TicketLoaded() == true && self.TicketCategoryStructureId() == null) {
                tabPage.IsLoading(true);
                Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({
                    ticketServiceStructureId: self.TicketServiceStructureId()
                }), function (result) {
                    if (result != null && result.TicketCategoryStructureId != null) {
                        self.TicketCategoryStructureId(result.TicketCategoryStructureId);
                        self.TicketCategoryStructureName(result.TicketCategoryStructureName);
                    }
                    tabPage.IsLoading(false);
                });
            }
        }
        BaoMenu.permissionEnable({
            ActionKey: "ActionRouting",
            Enabled: newValue != self.TicketStatusWaitsForApproval && !self.TicketLocked() && !self.IsReadonly(),
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "ActionOperate",
            Enabled: newValue != self.TicketStatusWaitsForApproval && !self.TicketLocked() && !self.IsReadonly(),
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "ActionClose",
            Enabled: newValue != self.TicketStatusWaitsForApproval && !self.TicketLocked() && !self.IsReadonly(),
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "ActionTicketReOpen",
            Enabled: newValue == self.TicketStatusClosed && !self.TicketLocked(),
            Context: tabPage.Context()
        });
    });
    self.subscribe(self.TabName, function (value) {
        if (value != "") {
            if (self.SearchPagingActive() && self.CurrentSearchIndex() != null) {
                tabPage.Title(value + " (" + (self.CurrentSearchIndex() + 1) + " / " + self.CurrentTotalCount() + ")");
            }
            else {
                tabPage.Title(value);
            }
        }
    });
    self.subscribe(self.ApprovalAllowed, function (newValue) {
        if (newValue != null) {
            BaoMenu.permissionEnable({
                ActionKey: "ActionApprove",
                Enabled: !self.IsReadonly() && self.ApprovalAllowed() && self.TicketApproveStateId() == null,
                Context: tabPage.Context()
            });
        }
    });
    self.UploadFinished = function () {
        self.HasDocuments(true);
        self.UpdateDocuments();
    };
    self.UpdateDocuments = function () { };
    self.CompleteCheck = function (ignoreClose) {
        if (ignoreClose == null) {
            ignoreClose = false;
        }
        var def = $.Deferred();
        var isComplete = true;
        if (self.AffectedPersonId() == null) {
            isComplete = false;
        }
        if (self.TicketTypeId() == null) {
            isComplete = false;
        }
        if (self.TicketPriorityId() == null) {
            isComplete = false;
        }
        if (self.TicketStatusId() == null) {
            isComplete = false;
        }
        if (self.TicketCategoryStructureId() == null && (self.TicketStatusId() == self.TicketStatusClosed || self.ActionCloseDialogIsOpen())) {
            isComplete = false;
        }
        if (self.TicketServiceStructureId() == null) {
            isComplete = false;
        }
        if (self.OnHoldUntilVisible() == true && Bao.Utils.String.IsNullOrEmpty(self.OnHoldUntilJs())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.ProblemShort())) {
            isComplete = false;
        }
        if (self.OwnerServiceProviderId() == null) {
            isComplete = false;
        }
        if (!isComplete) {
            def.resolve(false);
            new BaoDialogViewModel(Bao.Session.ApplicationName, _msgMandatoryFields, "info");
        }
        else if (self.TicketStatusId() == self.TicketStatusClosed && ignoreClose == false) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _ticketCloseMessage, "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result == true) {
                    def.resolve(true);
                }
                else {
                    def.resolve(false);
                }
            });
        }
        else if (self.OnHoldUntilVisible() && self.ValidateOnHoldDate() == false) {
            def.resolve(false);
            new BaoDialogViewModel(Bao.Session.ApplicationName, _msgOnHoldDateFuture, "info");
        }
        else {
            def.resolve(true);
        }
        return def.promise();
    };
    self.ValidateOnHoldDate = function () {
        var currentDate = moment();
        var onHoldDate = moment(self.OnHoldUntilJs(), Bao.Utils.DateTimeFormat);
        return onHoldDate > currentDate;
    };
    self.DeleteReferenceDocument = function () {
        var selectedId = self.SelectedReferenceDocumentRow().OpenData;
        var add = true;
        $.each(self.DocumentsToDelete(), function (index, id) {
            if (id == selectedId) {
                add = false;
                return;
            }
        });
        if (add === true) {
            self.DocumentsToDelete.push(selectedId);
            self.UpdateDocuments();
        }
    };
    self.ExportReferenceDocument = function () {
        self.DownloadReferenceDocument(self.SelectedReferenceDocumentRow());
    };
    self.ReferenceDocumentGridDblClick = function (item) {
        self.DownloadReferenceDocument(item);
    };
    self.DownloadReferenceDocument = function (item) {
        window.open(item.OpenUrl + "/" + item.OpenData);
    };
    self.DeleteService = function () {
        self.TicketServiceStructureName(null);
        self.TicketServiceStructureId(null);
        self.ApprovalRequired(false);
        self.TicketApproveStateId(null);
        self.UpdateEscalation();
    };
    self.DeleteCategory = function () {
        self.TicketCategoryStructureName(null);
        self.TicketCategoryStructureId(null);
    };
    self.GoToAffectedConfigurationItem = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem");
        newTab.UrlData({
            id: self.AffectedConfigurationItemId()
        });
        newTab.ObjectId(self.AffectedConfigurationItemId());
        AppTabController.AddTab(newTab);
    };
    self.GoToCauseConfigurationItem = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem");
        newTab.UrlData({
            id: self.CauseItemConfigurationItemId()
        });
        newTab.ObjectId(self.CauseItemConfigurationItemId());
        AppTabController.AddTab(newTab);
    };
    self.GoToAffectedPerson = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.AffectedPersonId()
        });
        newTab.ObjectId(self.AffectedPersonId());
        AppTabController.AddTab(newTab);
    };
    self.GoToReportingPerson = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.ReportingPersonId()
        });
        newTab.ObjectId(self.ReportingPersonId());
        AppTabController.AddTab(newTab);
    };
    self.GridDblClick = function (item) {
        var newTab = new TabPage();
        newTab.Url(item.OpenUrl);
        newTab.UrlData({
            id: item.OpenData
        });
        newTab.ObjectId(item.OpenData);
        AppTabController.AddTab(newTab);
    };
    self.RefreshDiary = function () {
        if (diaryLoaded === true) {
            if (self.Diary() != "" && self.Diary() != null) {
                self.Diary(null);
            }
            Bao.post("Ticket/GetDiary", JSON.stringify({
                id: self.TicketId(),
                version: self.Version()
            }), function (value) {
                self.DiaryHistory(value);
            });
        }
    };
    self.AffectedPersonChanged = function (selectedRow) {
        if (selectedRow != null) {
            self.AffectedPersonCustomerName(selectedRow.CustomerName);
            self.AffectedPersonCustomerPhone(selectedRow.Telephone);
            self.AffectedPersonCustomerEmail(selectedRow.Email);
            self.AffectedPersonCustomerId(selectedRow.CustomerId);
            self.AffectedPersonLocationId(selectedRow.LocationId);
        }
        else {
            self.AffectedPersonCustomerName("");
            self.AffectedPersonCustomerPhone("");
            self.AffectedPersonCustomerEmail("");
            self.AffectedPersonCustomerId(null);
            self.AffectedPersonLocationId(null);
        }
    };
    self.AffectedPersonDeleted = function () {
        self.AffectedPersonCustomerName(null);
        self.AffectedPersonCustomerPhone(null);
        self.AffectedPersonCustomerEmail(null);
    };
    self.ReportingPersonChanged = function (selectedRow) {
        if (selectedRow != null) {
            self.ReportingPersonCustomerName(selectedRow.CustomerName);
            self.ReportingPersonCustomerPhone(selectedRow.Telephone);
            self.ReportingPersonCustomerEmail(selectedRow.Email);
        }
        else {
            self.ReportingPersonCustomerName(null);
            self.ReportingPersonCustomerPhone(null);
            self.ReportingPersonCustomerEmail(null);
        }
    };
    self.ReportingPersonDeleted = function () {
        self.ReportingPersonCustomerName(null);
        self.ReportingPersonCustomerPhone(null);
        self.ReportingPersonCustomerEmail(null);
    };
    self.AffectedConfigurationItemChanged = function (selectedRow) {
        if (selectedRow != null) {
            self.AffectedConfigurationItemType(selectedRow.ConfigurationItemTypeName);
            self.AffectedConfigurationItemCustomerName(selectedRow.CustomerName);
            self.AffectedConfigurationItemBuilding(selectedRow.BuildingName);
            self.AffectedConfigurationItemRoom(selectedRow.Room);
        }
        else {
            self.AffectedConfigurationItemType(null);
            self.AffectedConfigurationItemCustomerName(null);
            self.AffectedConfigurationItemBuilding(null);
            self.AffectedConfigurationItemRoom(null);
        }
    };
    self.AffectedConfigurationItemDeleted = function () {
        self.AffectedConfigurationItemType(null);
        self.AffectedConfigurationItemCustomerName(null);
        self.AffectedConfigurationItemBuilding(null);
        self.AffectedConfigurationItemRoom(null);
    };
    self.CauseConfigurationItemChanged = function (selectedRow) {
        if (selectedRow != null) {
            self.CauseConfigurationItemType(selectedRow.ConfigurationItemTypeName);
            self.CauseConfigurationItemCustomerName(selectedRow.CustomerName);
            self.CauseConfigurationItemBuilding(selectedRow.BuildingName);
            self.CauseConfigurationItemRoom(selectedRow.Room);
        }
        else {
            self.CauseConfigurationItemType(null);
            self.CauseConfigurationItemCustomerName(null);
            self.CauseConfigurationItemBuilding(null);
            self.CauseConfigurationItemRoom(null);
        }
    };
    self.CauseConfigurationItemDeleted = function () {
        self.CauseConfigurationItemType(null);
        self.CauseConfigurationItemCustomerName(null);
        self.CauseConfigurationItemBuilding(null);
        self.CauseConfigurationItemRoom(null);
    };
    self.OwnerServiceProviderChanged = function () {
        if (self.OwnerPersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.OwnerPersonId(),
                serviceProviderId: self.OwnerServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.OwnerPersonName(null);
                    self.OwnerPersonId(null);
                }
            });
        }
        self.UpdateEscalation();
    };
    self.OwnerServiceProviderDeleted = function () {
        self.OwnerPersonDeleted();
    };
    self.OwnerPersonDeleted = function () {
        self.OwnerPersonId(null);
        self.OwnerPersonName(null);
    };
    self.DispatcherServiceProviderChanged = function () {
        if (self.DispatcherPersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.DispatcherPersonId(),
                serviceProviderId: self.DispatcherServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.DispatcherPersonName(null);
                    self.DispatcherPersonId(null);
                }
            });
        }
    };
    self.DispatcherServiceProviderDeleted = function () {
        self.DispatcherPersonDeleted();
    };
    self.DispatcherPersonDeleted = function () {
        self.DispatcherPersonId(null);
        self.DispatcherPersonName(null);
    };
    self.ServiceServiceProviderChanged = function () {
        if (self.ServicePersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.ServicePersonId(),
                serviceProviderId: self.ServiceServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.ServicePersonName(null);
                    self.ServicePersonId(null);
                }
            });
        }
    };
    self.ServiceServiceProviderDeleted = function () {
        self.ServicePersonDeleted();
    };
    self.ServicePersonDeleted = function () {
        self.ServicePersonId(null);
        self.ServicePersonName(null);
    };
    self.TicketUnlock = function () {
        var q = $.Deferred();
        if (self.TicketId() != null) {
            return Bao.post("Ticket/UnlockTicket", JSON.stringify({
                id: self.TicketId(),
                lockGuid: self.LockGuid()
            }));
        }
        else {
            q.resolve();
        }
        return q.promise();
    };
    self.BeforeClose = function (fn) {
        if (tabPage.IsDirty() == true && self.SaveAllowed() === true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _saveMessage, "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.CompleteCheck().then(function (completeResult) {
                        tabPage.IsLoading(true);
                        if (completeResult == true) {
                            self.Save().done(function () {
                                self.TicketUnlock().then(function () {
                                    tabPage.IsLoading(false);
                                    self.DestroyObject();
                                    fn();
                                });
                            });
                        }
                    });
                }
                else if (result === false) {
                    tabPage.IsLoading(true);
                    self.TicketUnlock().then(function () {
                        tabPage.IsLoading(false);
                        self.DestroyObject();
                        fn();
                    });
                }
            });
        }
        else {
            self.TicketUnlock();
            self.DestroyObject();
            fn();
        }
    };
    self.BeforeRefresh = function () {
        if (tabPage.IsDirty() && (self.SaveAllowed == null || self.SaveAllowed())) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _saveMessage, "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.CompleteCheck().then(function (completeResult) {
                        if (completeResult == true) {
                            self.Save().done(function () {
                                self.PerformRefresh();
                            });
                        }
                    });
                }
                else if (result === false) {
                    self.PerformRefresh();
                    ;
                }
            });
        }
        else {
            self.PerformRefresh();
        }
    };
    self.BeforeDelete = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                self.Delete();
            }
        });
    };
    self.RefreshTicketEscalationTab = function () {
        var def = $.Deferred();
        if (tabPageEscalation != null) {
            tabPageEscalation.ViewModel().PerformRefresh().then(def.resolve);
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        Bao.post("Ticket/ResetSession", JSON.stringify({
            sessionTabId: self.TabPage.SessionTabId
        })).then(function () {
            Bao.post("Ticket/Model", JSON.stringify({
                id: self.TicketId()
            })).then(function (ticketResult) {
                $.when(self.RefreshTicketEscalationTab(), tabPageDocuments.ViewModel().Refresh(), tabPageAssignment.ViewModel().Refresh(), tabPageEvaluation?.ViewModel().Refresh()).then(function () {
                    var value = ticketResult;
                    if (value.TicketNr != null && value.TicketNr != 0) {
                        tabPage.ObjectId(value.TicketNr);
                    }
                    else {
                        tabPage.ObjectId(value.TicketId);
                    }
                    ko.map.fromJS(value, self);
                    tabPage.DirtyFlag.reset();
                    BaoMenu.permissionEnable({
                        ActionKey: "TicketDelete",
                        Enabled: !self.IsReadonly(),
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "TicketSave",
                        Enabled: !self.IsReadonly(),
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "ActionRouting",
                        Enabled: !self.IsReadonly(),
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "ActionOperate",
                        Enabled: !self.IsReadonly(),
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "ActionClose",
                        Enabled: !self.IsReadonly(),
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "ActionApprove",
                        Enabled: !self.IsReadonly() && self.ApprovalAllowed() && self.TicketApproveStateId() == null,
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "ActionTicketReOpen",
                        Enabled: self.TicketStatusId() == self.TicketStatusClosed && !self.TicketLocked(),
                        Context: tabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "SendTicketReportMail",
                        Enabled: !self.IsNew(),
                        Context: self.TabPage.Context()
                    });
                    BaoMenu.permissionEnable({
                        ActionKey: "TicketRefresh",
                        Enabled: !self.IsNew(),
                        Context: self.TabPage.Context()
                    });

                    self.UpdateReactedButtonVisible().then(function () {
                        tabPage.IsLoading(false);
                    });
                });
            });
        });
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post("Ticket/Save", JSON.stringify({
            ticket: ko.map.toJS(self, true),
            deletedDocuments: self.DocumentsToDelete(),
            sessionTabId: self.TabPage.SessionTabId
        }), function (value) {
            self.SaveTime(value.Result);
            $.when(tabPageDocuments.ViewModel().Save(value.Result), tabPageAssignment.ViewModel().Save(value.Result)).then(function () {
                Bao.raiseEvent('user-tagging:save', { entityId: self.TicketId() });
                self.RefreshDiary();
                tabPage.DirtyFlag.reset();
                self.PerformRefresh();
            });
        });
    };
    /*
     * Delete Tickets
    */
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post("Ticket/Delete", JSON.stringify({
            ticketId: self.TicketId()
        }), function (result) {
            if (result.Result == true) {
                AppTabController.RemoveTab(tabPage);
            } else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            }
            tabPage.IsLoading(false);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage != null && tabPage.IsActiveTab != null && tabPage.IsActiveTab() === true) {
            switch (value.ActionKey()) {
                case "TicketSave":
                    self.CompleteCheck().then(function (completeResult) {
                        if (completeResult == true) {
                            self.Save();
                        }
                    });
                    break;
                case "ActionRouting":
                case "ActionClose":
                case "ActionOperate":
                    self.ShowActionDialog(value.ActionKey(), self.TicketId(), self);
                    break;
                case "ActionApprove":
                    self.Approve();
                    break;
                case "TicketRefresh":
                    self.BeforeRefresh();
                    break;
                case "TicketDelete":
                    self.BeforeDelete();
                    break;
                case "ActionTicketReOpen":
                    self.ReopenTicket();
                    break;
                case "TicketGenerateTicketTemplate":
                    self.GenerateTicketTemplate();
                    break;
                case "TicketAudit":
                    self.OpenTicketAuditDialog();
                    break;
                case "CreateTicketReport":
                    self.CreateTicketReport();
                    break;
                case "SendTicketReportMail":
                    self.SendReportMail();
                    break;
            }
        }
    }));
    self.CreateTicketReport = function () {
        self.TabPage.IsLoading(true);
        Bao.post("Ticket/CreateTicketReport", JSON.stringify({
            ticketId: self.TicketId()
        }), function (result) {
            self.TabPage.IsLoading(false);
            if (result.IsCreated == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    };
    self.SendReportMail = function () {
        self.TabPage.IsLoading(true);
        var dialog = new SendMailDialog(this, self.TicketId(), null);
        dialog.DialogTicket();
    };
    self.OpenTicketAuditDialog = function () {
        var ticketAuditDialog = new TicketAuditDialog(self.TicketId(), self.TabPage.Title(), self.TabPage);
        ticketAuditDialog.Open().then(function () { });
    };
    self.GenerateTicketTemplate = function () {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgGenerateTicketTemplate"), "yesno");
        questionDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                var newTab = new TabPage();
                newTab.Url("TicketTemplate");
                newTab.Object = {
                    ticketModel: ko.map.toJS(self, true)
                };
                AppTabController.AddTab(newTab);
            }
        });
    };
    self.ReopenTicket = function () {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgReopenTicketQuestion"), "question");
        questionDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                self.CompleteCheck(true).then(function (completeCheckResult) {
                    if (completeCheckResult) {
                        Bao.post("Ticket/ReopenTicket", JSON.stringify({
                            ticketId: self.TicketId()
                        }), function (reopenResult) {
                            if (reopenResult.Result == true) {
                                self.PerformRefresh();
                            }
                        });
                    }
                });
            }
        });
    };
    self.InitializeDataBindingTicketCategoryStructure = function (id) {
        return Bao.post("Ticket/GetCompleteTicketCategoryStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.TicketCategoryStructureName(value);
        });
    };
    self.InitializeDataBindingTicketServiceStructure = function (id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.TicketServiceStructureName(value);
        });
    };
    self.ShowActionDialog = function (actionKey, ticketId, model, unlockAfterSave) {
        if (typeof ticketId === "undefined") {
            ticketId = self.OpenData();
        }
        tabPage.IsLoading(true);
        Bao.post("Ticket/ShowActionDialog", JSON.stringify({
            sender: actionKey,
            ticketId: ticketId
        }), function (value) {
            var actionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            actionDialog.Template(value.Message);
            if (model == null) {
                model = new TicketViewModel(tabPage);
                ko.map.fromJS(value.Model, model);
            }
            actionDialog.ViewModel(model);
            var width = 0;
            switch (actionKey) {
                case "ActionRouting":
                    width = 460;
                    break;
                case "ActionClose":
                    self.ActionCloseDialogIsOpen(true);
                    width = 650;
                    break;
                case "ActionOperate":
                    width = 650;
                    break;
            }
            actionDialog.Width(width);
            actionDialog.Buttons([{
                    Title: _msgOk,
                    Enabled: ko.observable(true),
                    Click: function () {
                        model.CompleteCheck().then(function (completeResult) {
                            if (completeResult == true) {
                                if (unlockAfterSave === true) {
                                    model.LockGuid(null);
                                    model.LockSessionId(null);
                                }
                                if (actionKey == "ActionClose") {
                                    model.TicketStatusId(self.TicketStatusClosed);
                                    self.ActionCloseDialogIsOpen(false);
                                }
                                self.Save();
                                actionDialog.Close();
                            }
                        });
                    }
                }, {
                    Title: _msgCancel,
                    Enabled: ko.observable(true),
                    Click: function () {
                        self.ActionCloseDialogIsOpen(false);
                        actionDialog.Close();
                    }
                }]);
            actionDialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.OpenTreeDialog = function (type) {
        tabPage.IsLoading(true);
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: type,
            ticketTypeCategoryId: self.TicketTypeCategoryId()
        }), function (value) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogViewModel : any = {};
            dialogViewModel.NodeToggled = function (node) {
                if (node.Loaded() == false) {
                    tabPage.IsLoading(true);
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({
                        type: type,
                        parentId: parentId
                    }), function (value) {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                        tabPage.IsLoading(false);
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            var selectedServiceSubscription = dialogViewModel.SelectedService.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.TicketTypeCategoryName = ko.observable();
            var ticketTypeCategoryNameSubscription = dialogViewModel.TicketTypeCategoryName.subscribe(function () { });
            dialogViewModel.SearcherTicketService = {
                ObjectId: self.TicketTypeCategoryId,
                ObjectValue: "Category",
                SearchType: "TicketTypeCategory",
                AutoComplete: true,
                AutoSearch: true
            };
            dialogViewModel.SelectedCategory = ko.observable();
            var selectedCategorySubscription = dialogViewModel.SelectedCategory.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                tabPage.IsLoading(true);
                var selectedNode;
                switch (type) {
                    case "TicketService":
                        selectedNode = dialogViewModel.SelectedService();
                        if (selectedNode != null) {
                            if (selectedNode.IsAllowed()) {
                                return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({
                                    selectedTicketServiceId: selectedNode.Id()
                                }), function (result) {
                                    self.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                                    self.TicketServiceStructureId(result.TicketServiceStructureId);
                                    self.IsApprovalAllowed();
                                    self.OwnerPersonId(result.OwnerUserId);
                                    self.OwnerPersonName(result.OwnerUserName);
                                    self.OwnerServiceProviderId(result.OwnerRoleId);
                                    self.OwnerServiceProviderName(result.OwnerRoleName);
                                    self.DispatcherPersonId(result.DispatcherUserId);
                                    self.DispatcherPersonName(result.DispatcherUserName);
                                    self.DispatcherServiceProviderId(result.DispatcherRoleId);
                                    self.DispatcherServiceProviderName(result.DispatcherRoleName);
                                    self.TicketApproveStateId(null);
                                    self.ApprovalRequired(result.ApprovalRequired);
                                    if (self.ApprovalRequired() == true) {
                                        self.TicketStatusId(self.TicketStatusWaitsForApproval);
                                        ko.utils.arrayForEach(self.TicketStatuses(), function (ticketStatus: any) {
                                            if (ticketStatus.Key() == self.TicketStatusWaitsForApproval) {
                                                self.TicketStatusName(ticketStatus.Value());
                                            }
                                        });
                                    }
                                    if (self.TicketCategoryStructureId() == null) {
                                        self.TicketCategoryStructureId(result.TicketCategoryStructureId);
                                        self.TicketCategoryStructureName(result.TicketCategoryStructureName);
                                    }
                                    dialog.Close();
                                    self.UpdateEscalation();
                                    tabPage.IsLoading(false);
                                    selectedServiceSubscription.dispose();
                                    selectedServiceSubscription = null;
                                    dialogViewModel.SelectedService(null);
                                });
                            }
                        }
                        tabPage.IsLoading(false);
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                        break;
                    case "TicketCategory":
                        selectedNode = dialogViewModel.SelectedCategory();
                        if (selectedNode != null) {
                            if (selectedNode.IsAllowed()) {
                                return Bao.post("Ticket/GetTicketCategoryStructure", JSON.stringify({
                                    selectedTicketCategoryId: selectedNode.Id()
                                }), function (result) {
                                    self.InitializeDataBindingTicketCategoryStructure(result.TicketCategoryStructureId);
                                    self.TicketCategoryStructureId(result.TicketCategoryStructureId);
                                    dialog.Close();
                                    dialog = null;
                                    tabPage.IsLoading(false);
                                    selectedCategorySubscription.dispose();
                                    selectedCategorySubscription = null;
                                    dialogViewModel.SelectedCategory(null);
                                });
                            }
                        }
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketCategoryInvalidSelection"), "info");
                        tabPage.IsLoading(false);
                        break;
                }
                return null;
            };
            dialog.Width(667);
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Enabled: ko.observable(true),
                    Click: dialogViewModel.okClick
                }]);
            dialog.Open();
            tabPage.IsLoading(false);
            dialog.SetPosition();
        });
    };
    self.Focus = function () { };
    self.InitTicketModel = function (ticketTemplateId) {
        return Bao.post("Ticket/Model", JSON.stringify({
            id: tabPage.UrlData().id,
            affectedItemId: tabPage.UrlData().AffectedItemId,
            isHistory: tabPage.Url() == "Ticket/History",
            ticketTemplateId: ticketTemplateId,
            assignedTicketId: tabPage.UrlData().assignedTicketId
        }), function (model) {
            ko.map.fromJS(model, self, tabPage.DirtyFlag);
            tabPage.SessionTabId = self.SessionTabId();
            if (self.IsNew()) {
                tabPage.ObjectId(self.TicketId());
                self.UpdateEscalation();
                BaoMenu.permissionEnable({
                    ActionKey: "SendTicketReportMail",
                    Enabled: false,
                    Context: self.TabPage.Context()
                });
            }
        });
    };
    self.init = function () {
        var def = $.Deferred();
        if (tabPage.UrlData().id == null) {
            var ticketTemplateDialog = new TicketTemplateDialog(null);
            ticketTemplateDialog.OpenDialog().then(function (ticketTemplate) {
                var ticketTemplateId = null;
                if (ticketTemplate != null) {
                    if (ticketTemplate !== false) {
                        ticketTemplateId = ticketTemplate.TicketTemplateId;
                    }
                    self.InitTicketModel(ticketTemplateId).then(function () {
                        def.resolve();
                    });
                }
                else {
                    tabPage.$TabController.RemoveTab(tabPage);
                }
            });
        }
        else {
            return self.InitTicketModel(null);
        }
        return def.promise();
    };
    var baseLoaded = self.loaded;
    self.loaded = function () {
        var def = $.Deferred();
        self.InitParam();
        tabPage.SessionTabId = tabPage.ViewModel().SessionTabId();
        if (tabPage.Url() == "Ticket") {
            baseLoaded.call(self);
            if (!self.IsReadonly()) {
                BaoMenu.permissionEnable({
                    ActionKey: "TicketDelete",
                    Enabled: true,
                    Context: tabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: "TicketSave",
                    Enabled: true,
                    Context: tabPage.Context()
                });
            }
            else {
                BaoMenu.permissionEnable({
                    ActionKey: "TicketDelete",
                    Enabled: false,
                    Context: tabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: "TicketSave",
                    Enabled: false,
                    Context: tabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: "ActionRouting",
                    Enabled: false,
                    Context: tabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: "ActionOperate",
                    Enabled: false,
                    Context: tabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: "ActionClose",
                    Enabled: false,
                    Context: tabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: "ActionApprove",
                    Enabled: false,
                    Context: tabPage.Context()
                });
            }
            BaoMenu.permissionEnable({
                ActionKey: "ActionTicketReOpen",
                Enabled: tabPage.ViewModel().TicketStatusId() == tabPage.ViewModel().TicketStatusClosed && !tabPage.ViewModel().TicketLocked(),
                Context: tabPage.Context()
            });
                // start Refresh Button
                BaoMenu.permissionEnable({
                    ActionKey: TicketViewModel.prototype.PermissionRefresh,
                    Enabled: !self.IsNew(),
                    Context: tabPage.Context()
                });
                // end New Button

            if (tabPage.Object != null && tabPage.Object.ConfigurationItemId != null) {
                self.AffectedConfigurationItemId(tabPage.Object.ConfigurationItemId);
                self.AffectedConfigurationItemName(tabPage.Object.ConfigurationItemName);
            }
            if (tabPage.Object != null && tabPage.Object.PersonId != null) {
                self.AffectedPersonId(tabPage.Object.PersonId);
                self.AffectedPersonName(tabPage.Object.PersonName);
            }
            self.UpdateReactedButtonVisible().then(function () {
                self.refreshUserTagging();
                tabPage.IsLoading(false);
                tabPage.ViewModel().TicketLoaded(true);
                tabPage.DirtyFlag.reset();
                def.resolve();
            });
        }
        else if (tabPage.Url() == "Ticket/History") {
            BaoMenu.permissionEnable({
                ActionKey: "TicketDelete",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "TicketSave",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "TicketRefresh",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "ActionRouting",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "ActionOperate",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "ActionClose",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "ActionTicketReOpen",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "ActionApprove",
                Enabled: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionVisible({
                ActionKey: "TicketMoveForwardSearch",
                Visible: false,
                Context: tabPage.Context()
            });
            BaoMenu.permissionVisible({
                ActionKey: "TicketMoveBackwardSearch",
                Visible: false,
                Context: tabPage.Context()
            });
            self.refreshUserTagging();
            tabPage.IsLoading(false);
            tabPage.ViewModel().TicketLoaded(true);
            tabPage.DirtyFlag.reset();
            def.resolve();
        }
        return def.promise();
    };
    self.refreshUserTagging = function () {
        var self = this;
        self.showUserTaggingControl(false);
        self.showUserTaggingControl(true);
    }
    var basePerformMoveSearch = self.PerformMoveSearch;
    SearchPaging.prototype.PerformMoveSearch = function (newIndex, mode) {
        var self = this;
        self.TempNewIndex = newIndex;
        self.TabPage.IsLoading(true);
        var searchTab = AppTabController.SearchTabByObjectId("Search");
        if (searchTab != null) {
            searchTab.ViewModel().GetSearchItem(newIndex, self, mode).then(function (searchItem) {
                if (self.TabPage.IsActiveTab() == true) {
                    var tabFound = AppTabController.SearchTabByObjectId(searchItem.SimpleSearchId);
                    if (tabFound == null) {
                        tabFound = AppTabController.SearchTabByObjectId(searchItem.TicketNr);
                    }
                    if (tabFound != null) {
                        setTimeout(function () {
                            tabFound.ViewModel().CurrentTotalCount(self.CurrentTotalCount());
                            tabFound.ViewModel().CurrentSearchIndex(self.TempNewIndex);
                            tabFound.ViewModel().SearchPagingActive(true);
                            AppTabController.SelectTab(tabFound);
                            self.TabPage.IsLoading(false);
                        }, 0);
                    }
                    else {
                        self.SetSearchMovedItem(searchItem);
                    }
                }
            });
        }
    };
    self.IsCategoryFieldMandatory = ko.computed(function () {
        return self.TicketStatusId() == self.TicketStatusClosed || self.ActionCloseDialogIsOpen();
    });
}
Bao.inherit(TicketViewModel, SearchPaging);
TicketViewModel.prototype.PrimaryKey = "TicketId";
TicketViewModel.prototype.PermissionForward = "TicketMoveForwardSearch";
TicketViewModel.prototype.PermissionBackward = "TicketMoveBackwardSearch";
TicketViewModel.prototype.PermissionRefresh = "TicketRefresh";

TicketViewModel.prototype.IsApprovalAllowed = function () {
    var self = this;
    return Bao.post("Ticket/IsApprovalAllowed", JSON.stringify({
        ticketServiceStructureId: self.TicketServiceStructureId()
    }), function (result) {
        self.ApprovalAllowed(result);
    });
};
TicketViewModel.prototype.Approve = function () {
    var self = this;
    self.CompleteCheck().then(function (completeResult) {
        if (completeResult == true) {
            var approveDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgTicketApproveQuestion"));
            approveDialog.Width(600);
            approveDialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgApprove"),
                    Click: function () {
                        approveDialog.DialogResult(true);
                        approveDialog.Close();
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgReject"),
                    Click: function () {
                        approveDialog.DialogResult(false);
                        approveDialog.Close();
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        approveDialog.DialogResult(null);
                        approveDialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
            self.subscribe(approveDialog.DialogResult, function (approveResult) {
                if (approveResult === true || approveResult === false) {
                    self.Save().then(function () {
                        var approveStateId = "032ea19f-04fd-47e0-8599-e380f8cc305e";
                        if (approveResult == false) {
                            approveStateId = "76ae59cf-5d75-40dc-9a62-ce2ef66df142";
                        }
                        self.SetApprove(approveStateId);
                    });
                }
            });
            approveDialog.Open();
        }
    });
};
TicketViewModel.prototype.SetApprove = function (approveStateId) {
    var self = this;
    self.TabPage.IsLoading(true);
    Bao.post("Ticket/Approve", JSON.stringify({
        id: self.TicketId(),
        approveStateId: approveStateId
    }), function (result) {
        if (result == true) {
            BaoMenu.permissionEnable({
                ActionKey: "ActionApprove",
                Enabled: false,
                Context: self.TabPage.Context()
            });
            self.PerformRefresh();
        }
    });
};
export default TicketViewModel;